import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HttpHeaders, } from '@angular/common/http';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { ApidataService } from '../apidata.service';
import swal from 'sweetalert2';
import Swal from 'sweetalert2';
import { ReactiveFormsModule } from '@angular/forms';
import { Ng2SearchPipeModule } from '@ngx-maintenance/ng2-search-filter';
import { FormsModule } from '@angular/forms';
import { NgPipesModule } from 'ngx-pipes';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { saveAs } from 'file-saver';
import { SidebarComponent } from "../sidebar/sidebar.component";
import { SidebarforaccountsComponent } from '../sidebarforaccounts/sidebarforaccounts.component';
import { AngularDeviceInformationService } from 'angular-device-information';
import { RouterModule, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment, GINConstants } from '../../environments/environments';
declare var $: any;
@Component({
  selector: 'app-accountsetting',
  standalone: true,
  imports: [
    HttpClientModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgPipesModule,
    FilterPipeModule,
    Ng2SearchPipeModule,
    SidebarforaccountsComponent,
    RouterModule
  ],
  templateUrl: './accountsetting.component.html',
  styleUrl: './accountsetting.component.css',
  providers: [ApidataService],
})
export class AccountsettingComponent implements OnInit {
  @Output() open: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  accountSetting_msg = '';
  public profiletext: string = '';
  profiletextss = '';
  price_id;
  public new_password1 = '';
  model = {
    password_old: '',
    new_password1: '',
    new_password12: '',
  };
  savelanguage: Boolean = false;
  uk;
  us;
  public userPrefLanguage;
  new_password2 = '';
  password_old = '';
  firstName;
  lastName;
  emailAddress = '';
  comefromsite: boolean = false;
  all_records = [];
  current_subscription = ''
  visible: boolean = false;

  isUserLoggedin: boolean = false;
  authentication_token;
  premium_user_done;
  selectedplan = '';
  selectedplanaoumt = '';

  public accountSetting_check: Boolean = false;
  profile_id;
  dictWord;
  vocablury_parent: boolean;
  uklanguage;
  doneuk;
  dictioanryon;
  public myForm2: FormGroup;
  public dictListing: any[] = [];
  public savefiletext2: string = '';
  doneus;
  labguageFileText;
  subject_v_algo: boolean;
  public foraccount: boolean = false;
  public comefromgrammarin;
  public dictionaryStatus = '';

  public new_password12 = '';
  update_password = 'update_password';
  public password_old1 = '';
  docTitle2 = '';
  doc_id;
  dictionary;
  public searchTerm;
  public getsubscriptionhistory = [];
  public currentplan;
  public SpellCheckervalue: boolean;
  public Capitalizationvalue: boolean;
  public Punctuationvalue: boolean;
  public punctuationparentvalue: boolean;
  public articleparent: boolean;
  public contracted_forms: boolean;
  public Formalvalue: boolean;
  public formalintero: boolean;
  public verb_removal_solution: boolean;
  public Articlevalue: boolean = false;
  public to_infinitive_addition: boolean;
  public to_infinitive_simple: boolean;
  public preposition_formality_algorithm: boolean;
  public determine: boolean;
  public aux_addition: boolean;
  public subject_verb_algorithm_auxiliary: boolean;
  public subject_verb_algorithm_non_auxiliary: boolean;
  public verb_verb_algorithm: boolean;
  public active_passive_aux: boolean;
  public active_passive_modals: boolean;
  public pre_sv_aux: boolean;
  public modals_verb_agreement: boolean;
  Adjective_latin: boolean;
  public alllistoffilter: {};
  redundant: boolean;
  color;
  wikipediavalue: boolean;
  acadmicwritinglt: boolean;
  semanticsvalue: boolean;
  collocationvalue: boolean;
  compound: boolean;
  deroga_nav: boolean;
  forma_informals: boolean;
  sva_ant_non_aux: boolean;
  adjective_a_common: boolean;
  public punch_checker: boolean;
  public ltpossibletype: boolean;
  dobluenagtive: boolean;
  create_writing: boolean;
  conci_phrase: boolean;
  concis_p_z_i: boolean;
  grammarlt: boolean;
  commonwordsvalues: boolean;
  nonstandard: boolean;
  miscellanousvalue: boolean;
  simple_english: boolean;
  ltstyles: boolean;
  Adjective_compare: boolean;
  sva_Ant: boolean;
  PRP_replacement: boolean;
  PRP_replacement_in: boolean;
  space_character_removal: boolean;
  sequence_model_a: boolean;
  punctionltvalue: boolean;
  replace_sign: boolean;
  upperandlower_lt: boolean;
  captilzation_lt: boolean;
  typo_lt: boolean;
  article_algo: boolean;
  pre_article_algo: boolean;
  post_article_algo: boolean;
  sva_auxiliary: boolean;
  sva_non_auxiliary: boolean;
  auxiliary_addition: boolean;
  verb_verb_agrmt: boolean;
  contracted_forms_cons_rem: boolean;
  formal_tones: boolean;
  formal_tones_inter: boolean;
  determiner_algo: boolean;
  prp_replc_in_nn: boolean;
  esubText;
  to_inf_simple: boolean;
  to_inf_add_list: boolean;
  sequence_aux: boolean;
  syntaxs: boolean;
  allpunvalues: boolean;
  vocabulary_list: boolean;
  sequence_modals: boolean;
  preposition_formality: boolean;
  oxfordvalue: boolean;
  redundantvalue: boolean;
  wikipediavalues: boolean;
  claeirtyupdatedvalue: boolean;
  allgrammarvalues: boolean;
  styleupdatedvalue: boolean;
  prp_replacement_nn_z: boolean;
  httpClient: any;
  filterstatus: string;
  showWords: Boolean = false;
  selectedTab: string = 'tab1';
  filteredDictListing = [...this.dictListing];
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private apiservice: ApidataService, private http: HttpClient, private elementRef: ElementRef, private deviceInformationService: AngularDeviceInformationService) {
    this.fetchProfileData();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
  }


  ngAfterViewInit() {
    this.getpaymenthistory();
    this.getAllDictionaryWordsByProfileID();


  }

  ngOnInit(): void {
    this.profile_id = localStorage.getItem('profile_id');
    this.fetchProfileData();
    this.getpaymentstatus();
    this.getBrowserWidth();
    this.getAllDictionaryWordsByProfileID();

    this.activatedRoute.queryParams.subscribe((params) => {
      const { ref } = params;

      if (ref === 'premium') {
        this.changetabs('paymentdetails');
        this.selectedTab = 'tab5';
      } else {
        this.changetabs('alltabs');
      }
    });

    let group2: any = {};
    group2.new_password1 = new FormControl('', Validators.required);
    group2.new_password2 = new FormControl('', Validators.required);
    group2.password_old = new FormControl('', Validators.required);
    this.myForm2 = new FormGroup(group2);
    $(document).on('click', '.toggle-password99', function () {
      $(this).toggleClass('fa-eye fa-eye-slash');

      var input = $('#pass_log_id99');
      input.attr('type') === 'password'
        ? input.attr('type', 'text')
        : input.attr('type', 'password');
    });
    $(document).on('click', '.toggle-password2', function () {
      $(this).toggleClass('fa-eye fa-eye-slash');

      var input = $('#pass_log_id2');
      input.attr('type') === 'password'
        ? input.attr('type', 'text')
        : input.attr('type', 'password');
    });
    $(document).on('click', '.toggle-password3', function () {
      $(this).toggleClass('fa-eye fa-eye-slash');

      var input = $('#pass_log_id3');
      input.attr('type') === 'password'
        ? input.attr('type', 'text')
        : input.attr('type', 'password');
    });


    $(".tab_content").hide();
    $(".tab_content:first").show();


    $("ul.tabs li").click(function () {

      $(".tab_content").hide();
      var activeTab = $(this).attr("rel");
      $("#" + activeTab).fadeIn();

      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

      $(".tab_drawer_heading").removeClass("d_active");
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");


    });
    $(".tab_container").css("min-height", function () {
      return $(".tabs").outerHeight() + 50;
    });

    $(".tab_drawer_heading").click(function () {

      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel");
      $("#" + d_activeTab).fadeIn();

      $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");

      $("ul.tabs li").removeClass("active");
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });

    this.info_browser = this.deviceInformationService.getDeviceInfo().browser;
    this.info_os = this.deviceInformationService.getDeviceInfo().os;
    this.info_app = this.deviceInformationService.getDeviceType();


    this.getIPAddress()

  }
  info_city: string;
  info_country: string;
  info_browser: string;
  info_os: string;
  info_app: string;

  public getIPAddress() {
    this.http.get<any>(environment.API_URL + '/location').subscribe(
      (response) => {

        this.info_city = response.city
        this.info_country = response.country
      },
      (error) => {
        // console.error('Error fetching IP location:', error);
      }
    );
  }

  public routeTocontact() {
    this.router.navigate(['/contact-us'])
  }
  isMenuOpen = false;
  selectedLanguage = {
    name: 'American English',
    icon: '../../assets/images/plagiarism checker1/language.svg',
  };

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }


  selectLanguage(name: string, icon: string) {
    this.selectedLanguage.name = name;
    this.selectedLanguage.icon = icon;
    this.isMenuOpen = false;
  }


  @HostListener('document:click', ['$event'])
  closeMenuOnOutsideClick(event: Event) {
    const clickedElement = event.target as HTMLElement;

    if (!this.elementRef.nativeElement.contains(clickedElement) && !clickedElement.classList.contains('menu-btn')) {
      this.isMenuOpen = false;
    }
  }

  filter() {
    if (!this.searchTerm) {
      this.filteredDictListing = [...this.dictListing];
      this.showWords = false;

    }
    this.filteredDictListing = this.dictListing.filter(row =>
      row.word.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.showWords = true;
  }


  selectTab(tab: string): void {
    this.selectedTab = tab;
  }



  userInput: string = '';
  capitalize() {
    if (this.userInput) {
      this.userInput = this.userInput.charAt(0).toUpperCase() + this.userInput.slice(1);
    }
  }
  openHomeButtonModal() {
    const modalElement = document.getElementById('homeButtonModal');
    if (modalElement) {
      modalElement.classList.add('show');
      modalElement.style.display = 'block';
      modalElement.setAttribute('aria-hidden', 'false');
      modalElement.setAttribute('aria-modal', 'true');

      if (!document.querySelector('.modal-backdrop')) {
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
      }
    }
  }
  isPopupVisible = false;
  popupContent = '';
  onSidebarIconClick(icon: string) {
    this.popupContent = `You clicked on ${icon}`;
    this.isPopupVisible = true;
  }

  isDropdownVisible = false;


  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }


  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    const target = event.target as HTMLElement;

    if (!target.closest('.dropbtn')) {
      this.isDropdownVisible = false;
    }
  }


  gotohomepage() {
    this.router.navigate(['']);
  }

  public gotoeditor(type) {
    let data2 = JSON.stringify({ homeText: '', profile_id: this.profile_id });
    let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';
    this.apiservice.postResources(data2, url).subscribe((data) => {
      let receivedData = data;

      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } });
    });
  }

  public fetchProfileData() {

    this.profile_id = localStorage.getItem('profile_id');

    this.apiservice.getUserProfileContents(this.profile_id).subscribe((data) =>

      this.LoadProfileData(data)
    );
  }

  public LoadProfileData(data: Response) {
    let receivedData = data;
    this.firstName = receivedData['contents'][0][1];
    this.lastName = receivedData['contents'][0][2];
    this.emailAddress = receivedData['contents'][0][0];
    this.dictionaryStatus = receivedData['contents'][0][3];
    this.comefromgrammarin = receivedData['contents'][0][4];
    if (this.comefromgrammarin === 'grammarin') {
      this.comefromsite = true;
    }
    else {
      this.comefromsite = false;
    }

    const bopisElement = document.getElementById('bopis') as HTMLInputElement;

    if (bopisElement) {
      if (this.dictionaryStatus === 'off') {
        bopisElement.removeAttribute('checked');

      } else if (this.dictionaryStatus === 'on') {
        bopisElement.setAttribute('checked', 'true');

      }
    } else {
      // console.error("Element with ID 'bopis' not found.");
    }
  }










  updateAccountProfile(NP, CP, OP) {
    let txtFN = $('#firstname').val();
    let txtLN = $('#lastname').val();
    if (txtFN !== '' && txtLN !== '') {
      this.profile_id = localStorage.getItem('profile_id');
      if (
        (this.firstName != txtFN && txtFN.length <= 20) ||
        (this.lastName != txtLN && txtLN.length <= 20)
      ) {
        this.apiservice
          .updateProfileContents(this.profile_id, txtFN)
          .subscribe(() => {
            this.firstName = txtFN;
            this.lastName = txtLN;
            this.accountSettings_notifications(
              'Name updated successfully.',
              'green'
            );
          });
      } else if (
        txtFN != '' &&
        txtLN != '' &&
        this.firstName == txtFN &&
        this.lastName == txtLN
      ) {
      } else {
        this.accountSettings_notifications(
          'First Name and Last Name must be less than 20 characters',
          'red'
        );
      }
      if (NP && CP && OP) {
        if (NP.length < 8 || CP.length < 8) {
          this.accountSettings_notifications(
            'Your Password must be at least 8 characters long',
            'red'
          );
        } else if (NP == CP) {
          this.apiservice
            .updateUserPassword(this.profile_id, OP, NP, this.update_password)
            .subscribe((reply) => {
              if (reply) {
                if (
                  reply['password_update_message'] ==
                  'Your password has been changed successfully!'
                ) {
                  swal({
                    background: '#FFF9EB',
                    type: 'success',
                    title:
                      'Password has been updated! Please login to continue.',
                    showConfirmButton: true,
                    timer: 2000,
                    width: '600px',
                  });

                  localStorage.clear();
                  this.router.navigate(['/signin']);
                } else if (
                  reply['password_update_message'] ==
                  'You have entered a wrong password. Please try another one.'
                ) {
                  this.accountSettings_notifications(
                    'Name updated successfully but your old password is incorrect',
                    'red'
                  );
                } else if (
                  reply['password_update_message'] ==
                  'You have entered an old password. Please try another one.'
                ) {
                  this.accountSettings_notifications(
                    'You have entered an old password. Please try another one.',
                    'red'
                  );
                }
              }
            });
        } else {
          this.accountSettings_notifications(
            'New password and confirm password should be same.',
            'red'
          );
        }
      } else {
        if (NP || CP || OP) {
          this.accountSettings_notifications(
            'Please fill out all the fields of password section.',
            'red'
          );
        }
      }
    } else {
      this.accountSettings_notifications(
        'Please provide First & Last name.',
        'red'
      );
    }
  }

  updateProfileNames(NP, CP, OP) {
    let txtFN = $('#firstname').val();

    if (txtFN !== '') {
      this.profile_id = localStorage.getItem('profile_id');
      if (
        (this.firstName != txtFN && txtFN.length <= 20)
      ) {
        this.apiservice
          .updateProfileContents(this.profile_id, txtFN)
          .subscribe(() => {
            this.firstName = txtFN;
            localStorage.setItem('fullname', this.firstName);
            // this. showSuccess("Name updated successfully.", "");
            swal({
              background: "#FFFFFF",
              title: "Error",
              html: `
              <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                <div class="text-center" style="margin-top: 9%;">
                  <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
                  <div style="width: 323px; height: 64px; margin-left: 77px;">
                    <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
               Name updated successfully.
                    </p>
                  </div>
                </div>
              </div>
            `,
              showConfirmButton: false,
              width: "323px",
              timer: 4000
            });


          });
      } else if (
        txtFN != '' &&
        this.firstName == txtFN
      ) {
      } else {
        this.accountSettings_notifications(
          ' Name must be less than 20 characters',
          'red'
        );
      }

    } else {
      this.accountSettings_notifications(
        'Please provide  Name.',
        'red'
      );
    }
  }

  updatePassword(NP, CP, OP) {

    let txtFN = $('#firstname').val();
    let txtLN = $('#lastname').val();

    if (txtFN !== '' && txtLN !== '') {
      this.profile_id = localStorage.getItem('profile_id');

      if (NP && CP && OP) {
        if (NP.length < 8 || CP.length < 8) {
          this.accountSettings_notifications(
            'Your Password must be at least 8 characters long',
            'red'
          );
        } else if (NP == CP) {
          this.apiservice
            .updateUserPassword(this.profile_id, OP, NP, this.update_password)
            .subscribe((reply) => {
              if (reply) {
                if (
                  reply['password_update_message'] ==
                  'Your password has been changed successfully!'
                ) {
                  this.showSuccess("Password has been updated! Please login to continue.", "");
                  localStorage.clear();
                  setTimeout(() => {
                    this.router.navigate(['/signin']);
                  }, 2000);
                } else if (
                  reply['password_update_message'] ==
                  'You have entered a wrong password. Please try another one.'
                ) {
                  this.accountSettings_notifications(
                    ' your old password is incorrect',
                    'red'
                  );
                } else if (
                  reply['password_update_message'] ==
                  'You have entered an old password. Please try another one.'
                ) {
                  this.accountSettings_notifications(
                    'You have entered an old password. Please try another one.',
                    'red'
                  );
                }
              }
            });
        } else {
          this.accountSettings_notifications(
            'New password and confirm password should be same.',
            'red'
          );
        }
      } else {
        if (NP || CP || OP) {
          this.accountSettings_notifications(
            'Please fill out all the fields of password section.',
            'red'
          );
        }
      }
    }
  }


  error: boolean = false;
  errorAlerts;
  success: boolean = false;
  successAlert;



  showAlert(message, selector) {


    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts;').show();
    setTimeout(() => {
      $('#errorAlerts;').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
    let backdrop = document.querySelector('.modal-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop);
    }
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;

  }


  accountSettings_notifications(msg, color) {
    this.accountSetting_msg = msg;
    $('#accountSetting_div').show();
    this.accountSetting_check = true;
    if (color == 'red') {
      document.getElementById('accountSetting_div').style.color = 'red';
      document.getElementById('accountSetting_div').style.backgroundColor =
        '#ffefef';
      document.getElementById('accountSetting_div').style.float = 'right';
      document.getElementById('accountSetting_msgs').className =
        'fa fa-times-circle-o';
      setTimeout(function () {
        $('#accountSetting_div').hide();
        this.accountSetting_check = false;
        document.getElementById('accountSetting_div').style.color = null;
        document.getElementById('accountSetting_msgs').className = null;
        this.accountSetting_msg = '';
      }, 3000);
    } else if (color == 'green') {
      document.getElementById('accountSetting_div').style.color = 'green';
      document.getElementById('accountSetting_div').style.backgroundColor =
        '#e2f5e8';
      document.getElementById('accountSetting_div').style.float = 'right';
      document.getElementById('accountSetting_msgs').className =
        'fas fa-check-circle';
      setTimeout(function () {
        $('#accountSetting_div').hide();
        this.accountSetting_check = false;
        document.getElementById('accountSetting_div').style.color = null;
        document.getElementById('accountSetting_msgs').className = null;
        this.accountSetting_msg = '';
      }, 3000);
    }
  }


  updateUserDictionary() {
    let find: boolean = false;
    this.showWords = false;
    if (this.dictWord == null) {
      $('#dictLoader').html('Add at least 2 characters.');
      setTimeout(function () {
        $('#dictLoader').fadeOut('slow');
        $('#dictLoader').html('');
      }, 3000);
    }
    if (this.dictWord != null) {
      if (this.dictWord.length < 2) {
        $('#dictLoader').html('Add at least 2 characters.');
        setTimeout(function () {
          $('#dictLoader').fadeOut('slow');
          $('#dictLoader').html('');
        }, 3000);
      } else if (this.dictWord.length > 99) {
        $('#dictLoader').html('Words must be shorter than 100 characters');
        setTimeout(function () {
          $('#dictLoader').fadeOut('slow');
          $('#dictLoader').html('');
        }, 3000);
      } else if (this.dictWord.match(' ')) {
        $('#dictLoader').html('Your word can’t contain any spaces.');
        setTimeout(function () {
          $('#dictLoader').fadeOut('slow');
          $('#dictLoader').html('');
        }, 3000);
      } else {
        for (let i = 0; i < this.all_records.length; i++) {
          var checldicwordsalready = this.all_records[i][2];
          if (this.dictWord === checldicwordsalready) {
            find = true;
            break;
          }
        }
        if (find) {
          $('#dictLoader').html('Word already added.');
          setTimeout(function () {
            $('#dictLoader').fadeOut('slow');
            $('#dictLoader').html('');
          }, 3000);
        } else {
          this.apiservice
            .addDictionaryWord(this.profile_id, this.dictWord)
            .subscribe((data) => this.handleAddDictData(data));
        }
      }
    }
  }

  deleteDictWord(dic_id) {
    var c = confirm('Are you sure to delete?');
    if (c == true) {
      this.profile_id = localStorage.getItem('profile_id');
      this.apiservice.deleteDictWordByID(this.profile_id, dic_id).subscribe(
        (data) => {
          this.handleDictDataDeleted(data);
        }
      );
    }
  }

  handleDictDataDeleted(data: Response) {
    let receivedData = data;
    this.all_records = receivedData['contents'];

    this.dictListing = [];

    for (let i = 0; i < this.all_records.length; i++) {
      this.dictListing.push({
        dic_id: this.all_records[i][0],
        user_id: this.all_records[i][1],
        word: this.all_records[i][2],
        doc: this.all_records[i][3],
      });
    }
    $('#savefiletext2').html('<i class="fas fa-check-circle me-1"></i>Deleted Successfully!');
    setTimeout(function () {
      $('#savefiletext2').hide();
      $('#savefiletext2').html('');
    }, 3000);
    setTimeout(function () {
      $('#dictLoader').fadeOut('slow');
      $('#dictLoader').html('');
    }, 2000);

  }
  handleAddDictData(data: Response) {

    this.dictWord = '';

    let receivedData = data;

    this.all_records = receivedData['contents'];

    $('#savefiletext3').html('<i class="fas fa-check-circle me-1"></i>Added Successfully!');
    $('#savefiletext3').show();
    setTimeout(function () {
      $('#savefiletext3').hide();
      $('#savefiletext3').html('');
    }, 3000);
    this.dictListing = [];

    for (let i = 0; i < this.all_records.length; i++) {

      this.dictListing.push({
        dic_id: this.all_records[i][0],
        user_id: this.all_records[i][1],
        word: this.all_records[i][2],
        doc: this.all_records[i][3],
      });
    }

    setTimeout(function () {
      $('#dictLoader').fadeOut('slow');
      $('#dictLoader').html('');
    }, 2000);
  }

  logout() {
    this.apiservice.logout();
    this.router.navigate(['/']);
    localStorage.clear();
  }

  handleLangChange(data: Response) {
    var self = this;
    let receivedData = data;
    this.userPrefLanguage = receivedData['contents'];
    this.labguageFileText = 'Saved Successfully';
    $('#labguageFileText').show();
    setTimeout(function () {
      $('#labguageFileText').hide();
    }, 3000);
    this.savelanguage = true;
    this.getLanguageofUser();
  }

  getLanguageofUser() {
    this.profile_id = localStorage.getItem('profile_id');
    this.apiservice
      .getPreferredLangByProfileID(this.profile_id)
      .subscribe((data) => this.handleLang(data));
  }

  handleLang(data: Response) {
    var self = this;
    let receivedData = data;
    this.userPrefLanguage = receivedData['contents'];
    $('#uk_icon').removeClass('activeLanguage');
    $('#usa_icon').removeClass('activeLanguage');
    $('#uk_icon').removeClass('active');
    $('#usa_icon').removeClass('active');

    if (this.userPrefLanguage == 'uk') {
      $('#langNameSpan').html('UK');
      $('#uk_icon').addClass('active');
      $('#uk_icon').addClass('activeLanguage');
    } else {
      $('#langNameSpan').html('US');
      $('#usa_icon').addClass('active');
      $('#usa_icon').addClass('activeLanguage');
    }
    $('#btn_tool_language').removeClass('active');
    $('#langNameLoad').html('');
  }

  handletoggleDictionaryData(data: Response) {
    this.dictionary = data;
    this.dictioanryon = this.dictionary.contents;
    this.dictWord = '';
    $('#dictLoaderonoffmsg').html('Updated Successfully');
    setTimeout(function () {
      $('#dictLoaderonoffmsg').fadeOut('slow');
      $('#dictLoaderonoffmsg').html('');
    }, 3000);
  }

  public changetabs(tab) {
    if (tab === 'alltabs') {
      $('#genalsetting').show();
      $('#languages').hide();
      $('#paymentdetails').hide();
      $('#dictionarytab').hide();
      $('#cusotmizedtab').hide();
      $('#alltabs').css('background-color', '#E7E7EC');
      $('#Dictionary').css('background-color', 'white');
      $('#Subscription').css('background-color', 'white');
      $('#Language').css('background-color', 'white');
      $('#Custmoized').css('background-color', 'white');
    } else if (tab === 'languages') {
      this.getLanguageofUser();
      $('#genalsetting').hide();
      $('#languages').show();
      $('#paymentdetails').hide();
      $('#dictionarytab').hide();
      $('#cusotmizedtab').hide();
      $('#Language').css('background-color', '#E7E7EC');
      $('#alltabs').css('background-color', 'white');
      $('#Subscription').css('background-color', 'white');
      $('#Dictionary').css('background-color', 'white');
      $('#Custmoized').css('background-color', 'white');
    } else if (tab === 'paymentdetails') {
      this.getpaymenthistory();
      $('#paymentdetails').show();
      $('#languages').hide();
      $('#genalsetting').hide();
      $('#dictionarytab').hide();
      $('#cusotmizedtab').hide();
      $('#Subscription').css('background-color', '#E7E7EC');
      $('#alltabs').css('background-color', 'white');
      $('#Language').css('background-color', 'white');
      $('#Dictionary').css('background-color', 'white');
      $('#Custmoized').css('background-color', 'white');
    } else if (tab === 'dictionarytab') {
      this.getAllDictionaryWordsByProfileID();
      $('#dictionarytab').show();
      $('#languages').hide();
      $('#paymentdetails').hide();
      $('#genalsetting').hide();
      $('#cusotmizedtab').hide();
      $('#Dictionary').css('background-color', '#E7E7EC');
      $('#Subscription').css('background-color', 'white');
      $('#alltabs').css('background-color', 'white');
      $('#Language').css('background-color', 'white');
      $('#Custmoized').css('background-color', 'white');
    } else if (tab === 'cusotmizedtab') {
      $('#cusotmizedtab').show();
      $('#dictionarytab').hide();
      $('#languages').hide();
      $('#paymentdetails').hide();
      $('#genalsetting').hide();

      $('#Custmoized').css('background-color', '#E7E7EC');
      $('#Dictionary').css('background-color', 'white');
      $('#Subscription').css('background-color', 'white');
      $('#alltabs').css('background-color', 'white');
      $('#Language').css('background-color', 'white');
    }
  }
  toggle() {
    this.visible = !this.visible;
    this.foraccount = true;
    if (this.visible) {
      $('#hidefortesting').click(function () {
        $('nav').hide();
      });
      this.open.emit(null);
    } else {
      $('#showfortesting').click(function () {
        $('nav').show();
      });
      this.close.emit(null);
    }
  }
  clearprofilefileds(txtFN, txtLN) {
    txtFN = $('#firstname').val();
    txtLN = $('#lastname').val();
    $('#firstname').val(this.firstName);
    $('#lastname').val(this.lastName);
  }

  public getpaymenthistory() {
    let data = JSON.stringify({ user_id: this.profile_id });
    let url = environment.API_URL + '/api/getBillingHistory';
    this.apiservice.postResources(data, url).subscribe((data) => {

      this.current_subscription = data['plan_details'];
      this.getsubscriptionhistory = data['subscription_history'];
      this.currentplan = this.getsubscriptionhistory['0'];

    });
  }
  public getBrowserWidth = function () {
    if (window.innerWidth < 768) {
      this.router.navigate(['/notformobile']);

      this.msgforsmallscreen = true;
      return 'xs';
    } else if (window.innerWidth < 991) {

      this.msgforsmallscreen = false;

      return 'sm';
    } else if (window.innerWidth < 1199) {

      this.msgforsmallscreen = false;

      return 'md';
    } else {

      this.msgforsmallscreen = true;

      return 'lg';
    }
  };

  public getlanguageapi() {
    this.getLanguageofUser();
  }

  public updateLanguageForUseruk(lang) {

    lang = uk;
    var uk = lang;
    this.userPrefLanguage = lang;
    this.profile_id = localStorage.getItem('profile_id');
    this.apiservice
      .updateUserLanguage(this.profile_id, 'uk')
      .subscribe((data) => this.handleLangChange(data));
  }

  public updateLanguageForUser(lang) {
    $('#langNameLoad').html(
      '<img alt="Loading" src="../assets/images/loader-ajax.gif">'
    );
    this.userPrefLanguage = lang;
    this.profile_id = localStorage.getItem('profile_id');
    this.apiservice.updateUserLanguage(this.profile_id, 'us').subscribe(
      (data) => this.handleLangChange(data)
    );
  }

  toggleDictionary(value) {
    $('#dictLoaderonoffmsg').html(
      '<img alt="Loading" src="../assets/images/loader-ajax.gif">'
    );
    if (this.dictionaryStatus == 'on') {
      this.dictionaryStatus = 'off';
      this.apiservice
        .toggleDictionaryByProfileID(this.profile_id, this.dictionaryStatus)
        .subscribe((data) => this.handletoggleDictionaryData(data));
    } else if (this.dictionaryStatus == 'off') {
      this.dictionaryStatus = 'on';
      this.apiservice
        .toggleDictionaryByProfileID(this.profile_id, this.dictionaryStatus)
        .subscribe((data) => this.handletoggleDictionaryData(data));
    }
  }

  public getAllDictionaryWordsByProfileID() {
    const token = localStorage.getItem("token");

    this.profile_id = localStorage.getItem("profile_id");
    this.apiservice.getAllDictionaryWords(this.profile_id, token).subscribe(
      (data) => this.handleDictData(data)

    );
  }
  public handleDictData(data: Response) {
    let receivedData = data;
    this.all_records = receivedData["contents"];

    this.dictListing = [];

    for (let i = 0; i < this.all_records.length; i++) {
      this.dictListing.push({
        dic_id: this.all_records[i][0],
        user_id: this.all_records[i][1],
        word: this.all_records[i][2],
        doc: this.all_records[i][3],
      });
    }
  }

  downloadinvoice(invoice_id: string): void {
    this.apiservice.downloadpdfpaymentinvoice(invoice_id, this.profile_id).subscribe(
      (data: Blob) => {
        if (data instanceof Blob) {
          const blob = new Blob([data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `invoice_${invoice_id}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } else {
          // console.error('Expected blob response but received:', data);
        }
      },
      (error) => {
        // console.error('Download error:', error);
        if (
          error.error instanceof Blob &&
          error.error.type === 'application/json'
        ) {
          error.error.text().then((errorText: string) => {
            // console.error('Error response:', JSON.parse(errorText));
          });
        }
      }
    );
  }

  public saveTextRedirect(type) {
    let data2 = JSON.stringify({ homeText: '', profile_id: this.profile_id });

    let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

    this.apiservice.postResources(data2, url).subscribe((data) => {
      let receivedData = data;
      this.doc_id = receivedData['new_doc_id'];
      // this.router.navigate(['/document/', this.doc_id]);
      this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } });
    });
  }
  subscribed_user: boolean = false;
  public getpaymentstatus() {
    let data = JSON.stringify({ user_id: this.profile_id });
    let url = environment.API_URL + '/api/checkSubscriptionStatus';
    this.apiservice.postResources(data, url).subscribe((data) => {
      let datas: any = data['response'];
      if (datas['0'] === 'premium_user' || datas['0'] === 'free_trial') {
        this.subscribed_user = true;
        this.filterstatus = 'premium';
        localStorage.setItem('premium_user_done', JSON.stringify(datas[0] === 'premium_user' || datas[0] === 'free_trial'));

        const storedStatus = JSON.parse(localStorage.getItem('premium_user_done'));
        this.premium_user_done = storedStatus;

      } else {

        this.filterstatus = 'aftersignup';

      }

    });
  }


  public unsubscribeplan() {
    Swal({
      title: 'Are you sure you want to cancel the subscription?',
      text: 'You will lose access to premium features.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, cancel it!',
      cancelButtonText: 'Cancel ',
      width: '500px',
      background: '#fff'
    }).then((result) => {
      if (result.value) {
        let data = JSON.stringify({ user_id: this.profile_id });
        let url = environment.API_URL + '/api/cancelSubscription';

        this.apiservice.postResources(data, url).subscribe((data) => {
          let datas: any = data['response'];

          this.showSuccess("Subscription has been Canceled.", "");
          this.subscribed_user = false;

          location.reload();

        });
      } else {

      }
    });
  }


  goTOHelpCenter() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.router.navigate(['/help-center'])

  }
  public paymentapiforbasicplan() {
    this.price_id = 'price_1Q6AFpIcvPV98dDokZi78LKx'

    this.apiservice.callpaymentapi(this.profile_id, this.price_id).subscribe(data => {
      if (data.response === 'You are already subscribed. Please cancel previous subscription before getting new Subscription.') {
        this.showAlert(data.response, "");
      } else {
        window.open(data.url, '_blank');
      }
    })
  }
  public paymentapiforProfessional() {
    this.price_id = 'price_1Q6AeuIcvPV98dDoc2fUYvhM'

    this.apiservice.callpaymentapi(this.profile_id, this.price_id).subscribe(data => {

      if (data.response === 'You are already subscribed. Please cancel previous subscription before getting new Subscription.') {
        this.showAlert(data.response, "");
      } else {
        window.open(data.url, '_blank');
      }

    })
  }
  public paymentapianual() {
    this.price_id = 'price_1Q6Ag7IcvPV98dDoHGszhDz0'

    this.apiservice.callpaymentapi(this.profile_id, this.price_id).subscribe(data => {
      if (data.response === 'You are already subscribed. Please cancel previous subscription before getting new Subscription.') {
        this.showAlert(data.response, "");
      } else {
        window.open(data.url, '_blank');
      }

    })
  }




  navigateTosignup() {
    this.router.navigate(['/signup']);
  }

  public pickerApiLoaded = false;
  public oauthToken?: any;
  selectedPlan: any = 'Quarterly';
  hoveredPlan: string | null = null;

  onHover(plan: string): void {
    this.selectedPlan = plan;
  }

  onLeave(): void {
    this.selectedPlan = 'Quarterly';
  }

  onSelect(plan: string): void {
    this.selectedPlan = plan;
  }
  checkUserIdAndRoute(planname, amount, price_id) {
    this.selectedplan = planname;
    this.selectedplanaoumt = amount
    localStorage.setItem('plan', this.selectedplan);
    localStorage.setItem('amount', this.selectedplanaoumt)
    localStorage.setItem('price_id', price_id)
    this.router.navigate(['plans']);
  }
  navigateToplans() {
    this.router.navigate(['/plans']);
  }
}


